import config from 'temp/config';

const endpoint = '/api/sitecore/favorites';

export function getFavorites() {
  const baseUrl = config.sitecoreApiHost + `${endpoint}`;

  return fetch(baseUrl)
    .then((res) => res.json())
    .catch((e) => console.log(e));
}

export function saveFavorite(id) {
  if (!id) return false;

  const baseUrl = config.sitecoreApiHost + `${endpoint}/save?id=${id}`;

  return fetch(baseUrl, { method: 'POST' }).then((res) => res.json());
}

export function deleteFavorite(id) {
  if (!id) return false;

  const baseUrl = config.sitecoreApiHost + `${endpoint}/delete?id=${id}`;

  return fetch(baseUrl, { method: 'DELETE' }).then((res) => res.json());
}
